<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end" opened="false">
		<ca-inventory-sneak-peek [inventory]="selectedRow" (closeRequested)="closeSidenav()"></ca-inventory-sneak-peek>
	</mat-sidenav>

	<mat-sidenav-content>
		<app-generic-grid
			[pageName]="pageName"
			[selection]="'multiple'"
			[filters]="filters"
			[allowAdding]="true"
			[selectedRowKeys]="selectedRowKeys"
			[toolbarActions]="toolbarActions"
			[dataSource]="dataSource"
			[columns]="columns"
			[allowSelectAll]="false"
			(addAction)="newInventory()"
			(rowDblClick)="onRowDblClick($event)"
			(selectionChanged)="onSelectionChanged($event)"
		>
			<ng-template cellTemplateRef="siteATemplate" let-data>
				<div>
					<div class="customer-inv-grid-site-name">{{ data.data.siteA?.siteId }}</div>
					<div class="customer-inv-grid-site-address">{{ data.data.siteA?.building?.address?.searchAddress }}</div>
				</div>
			</ng-template>
			<ng-template cellTemplateRef="siteZTemplate" let-data>
				<div>
					<div class="customer-inv-grid-site-name">{{ data.data.siteZ?.siteId }}</div>
					<div class="customer-inv-grid-site-address">{{ data.data.siteZ?.building?.address?.searchAddress }}</div>
				</div>
			</ng-template>
		</app-generic-grid>
	</mat-sidenav-content>
</mat-sidenav-container>
